import { combineReducers } from '@reduxjs/toolkit';
import storeListReducer from './storeList/storeSlice';
import getJStoreListReducer from './getJStoreListSlice';
import getJPositionListReducer from './getJPositionListSlice';
import getJDepartmentListReducer from './getJDepartmentListSlice';
import enumOptionsReducer from './enumOptionsSlice';
import dictOptionsReducer from './dictOptionsSlice';
import chuanglanTemplateOptionsReducer from './chuanglanTemplateOptionsSlice';

// 合并 components 模块下的所有 reducer
const componentsReducer = combineReducers({
  storeList: storeListReducer,
  getJStoreList: getJStoreListReducer,
  getJPositionList: getJPositionListReducer,
  getJDepartmentList: getJDepartmentListReducer,
  enumOptions: enumOptionsReducer,
  dictOptions: dictOptionsReducer,
  chuanglanTemplateOptions: chuanglanTemplateOptionsReducer
});

export default componentsReducer;
